import { Injectable } from '@angular/core';
import { HREF } from '@core';

type HistoryItem = {
  name: string;
  url: string;
};

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryStorageService {
  private storageKey = 'navigationHistoryStorage';

  push(item: HistoryItem): void {
    const history = this.getHistory();
    history.push(item);
    this.setHistory(history);
  }

  pop(): HistoryItem | null {
    const history = this.getHistory();
    if (history.length > 0) {
      const lastItem = history.pop();
      this.setHistory(history);
      return lastItem || null;
    }
    return null;
  }

  // Will be helpful for data analytics purposes
  getPrevious(): HistoryItem | null {
    const history = this.getHistory();
    if (history.length > 1) {
      return history[history.length - 2] || null;
    }
    return null;
  }

  isFirstPage(): boolean {
    const history = this.getHistory();
    return history.length <= 1;
  }

  isFirstPageOrHome(): boolean {
    return window.location.pathname === `/${HREF.HOME}` || this.isFirstPage();
  }

  clearAll(): void {
    window.sessionStorage.removeItem(this.storageKey);
  }

  private getHistory(): HistoryItem[] {
    const history = window.sessionStorage.getItem(this.storageKey);
    if (history && this.isValidJSON(history)) {
      return JSON.parse(history);
    }
    return [];
  }

  private setHistory(history: HistoryItem[]): void {
    window.sessionStorage.setItem(this.storageKey, JSON.stringify(history));
  }

  private isValidJSON(item: string): boolean {
    if (item === 'undefined') return false;
    try {
      JSON.parse(item);
      return true;
    } catch (error) {
      return false;
    }
  }
}
